import React from 'react';
import NextImage, { ImageProps } from 'next/image';

interface BlurImage extends ImageProps {}

export function BaseBlurImage(props: BlurImage) {
    return (
        <NextImage
            {...props}
            blurDataURL="/images/default-course-image.jpeg"
            placeholder="blur"
            sizes="50vw"
        />
    );
}
